module.exports = __webpack_public_path__ + "static/media/bryce.5ae07da6.jpg";